/* Violet Eyes cart page: keep the estimated-total block in step after a piece is removed,
   and hide the summary column when the cart becomes empty. */
(() => {
  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event && event.cartData;
      if (!cart || typeof cart.items_subtotal_price !== 'number') return;
      const subtotal = cart.items_subtotal_price / 100;
      const currency = ` ${cart.currency || 'ILS'}`;

      document.querySelectorAll('#main-cart-footer *').forEach((element) => {
        if (!element.tagName.startsWith('ESTIMATED-TOTAL-')) return;
        element.base = subtotal;
        const itemsLine = element.querySelector('[class^="ai-estimated-total__line-"] span:last-child');
        if (itemsLine) itemsLine.textContent = subtotal.toFixed(2) + currency;
        const select = element.querySelector('[data-shipping]');
        if (select) select.dispatchEvent(new Event('change'));
      });

      const summary = document.getElementById('main-cart-footer');
      if (summary) summary.classList.toggle('is-empty', cart.item_count === 0);
      document.querySelectorAll('.ve-cart-recs-section').forEach((section) => {
        section.hidden = cart.item_count === 0;
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* City and shipping in the cart summary box (sections/ve-cart-summary.liquid; until 19 Oct a separate
   "Get shipping estimates" box). One row: "Shipping" · city field · Calculate. After Calculate a remote
   area folds the row into "Shipping · Eilat · rate name  Change  ₪65" straight away; any other town
   shows the regular rates to pick from, and the pick folds it the same way. Total is always shown
   ("₪230 + shipping" until a rate is set). Change opens the city row again. City and pick are kept
   for the visit (sessionStorage). The City field suggests towns as the shopper types:
   the official list of Israeli towns (assets/ve-towns.js: [Hebrew, English] pairs, loaded the first
   time the field is used), the remote-areas list and the section's "More city names". Hebrew typing
   suggests Hebrew names, Latin typing English names. Arrow keys move, Enter picks, Esc closes.
   Calculate: a city on none of the lists shows "We couldn't find this city…" and no rates
   (setting "Only accept cities on the list"). Matching ignores spaces, hyphens, quotes, dots, brackets and doubled
   י / ו, and the
   parts of a double name count on their own ("תל אביב" for "תל אביב - יפו", "גוש חלב" for
   "ג'ש (גוש חלב)"). Only the full names decide the remote-area rate.
   No request to Shopify. If the town list can't load, any city is accepted (as before). */
if (!customElements.get('ve-ship-estimate')) {
  const HEBREW = /[֐-׿]/;
  /* Spaces, hyphens, quotes, dots and brackets don't count, and a doubled י or ו inside a word
     counts once ("קריית גת" = the list's "קרית גת", "תקוה" = "תקווה"). */
  const norm = (value) =>
    String(value || '')
      .toLowerCase()
      .split(/[\s\-–—־'"״׳`’.,()]+/)
      .map((word) => word.replace(/([יו])\1+/g, '$1'))
      .join('');
  /* English spellings vary ("Kiryat" / "Qiryat", "Kfar Saba" / "Kefar Sava"): a sound-alike key
     per word (vowels after the first letter dropped, q→k, w/b→v, ch/kh→h, tz/ts→z, doubles once).
     Used for suggestions, and to accept a typed English name that sounds like exactly one town. */
  const soundKey = (value) =>
    String(value || '')
      .toLowerCase()
      .split(/[^a-z]+/)
      .filter(Boolean)
      .map((word) => {
        let key = word
          .replace(/ch|kh/g, 'h')
          .replace(/ph/g, 'f')
          .replace(/tz|ts/g, 'z')
          .replace(/[cq]/g, 'k')
          .replace(/[wb]/g, 'v');
        key = key[0] + key.slice(1).replace(/[aeiouy]/g, '');
        return key.replace(/(.)\1+/g, '$1');
      })
      .join('');
  /* Bigger towns come first among equally good suggestions ("תל" → תל אביב - יפו first). */
  const MAIN_TOWNS = new Set(
    [
      'ירושלים', 'תל אביב - יפו', 'חיפה', 'ראשון לציון', 'פתח תקווה', 'אשדוד', 'נתניה', 'באר שבע',
      'בני ברק', 'חולון', 'רמת גן', 'אשקלון', 'רחובות', 'בת ים', 'בית שמש', 'כפר סבא', 'הרצליה',
      'חדרה', 'מודיעין-מכבים-רעות', 'נצרת', 'רמלה', 'לוד', 'רעננה', 'ראש העין', 'הוד השרון',
      'קרית גת', 'נהריה', 'עפולה', 'אילת', 'קרית אתא', 'גבעתיים', 'קרית ביאליק', 'קרית מוצקין',
      'קרית ים', 'נס ציונה', 'אור יהודה', 'יבנה', 'רמת השרון', 'טבריה', 'צפת', 'דימונה', 'ערד',
      'קרית שמונה', 'אום אל-פחם', 'רהט', 'נוף הגליל', 'קרית אונו', 'קרית מלאכי', 'אופקים', 'שדרות',
      'נתיבות', 'יקנעם עילית', 'זכרון יעקב', 'כרמיאל', 'עכו', 'טירת כרמל', 'גדרה', 'קיסריה',
      'אלעד', 'ביתר עילית', 'מודיעין עילית', 'אריאל', 'מעלה אדומים',
    ].map(norm)
  );
  let townsPromise = null;
  const loadTowns = (src) => {
    if (window.veTowns) return Promise.resolve({ towns: window.veTowns, aliases: window.veTownAliases || [] });
    if (!src) return Promise.resolve(null);
    if (!townsPromise) {
      townsPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () =>
          resolve(
            Array.isArray(window.veTowns) ? { towns: window.veTowns, aliases: window.veTownAliases || [] } : null
          );
        script.onerror = () => resolve(null);
        document.head.appendChild(script);
      });
    }
    return townsPromise;
  };

  customElements.define(
    've-ship-estimate',
    class VeShipEstimate extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const readJson = (selector) => {
          try {
            const value = JSON.parse(this.querySelector(selector).textContent);
            return Array.isArray(value) ? value : [];
          } catch (error) {
            return [];
          }
        };
        this.remoteNames = readJson('[data-ve-remote-list]');
        this.extraNames = readJson('[data-ve-town-extra]');
        this.remote = new Set(this.remoteNames.map(norm).filter(Boolean));
        this.onlyListed = this.dataset.onlyListed !== 'false';
        this.townsLoaded = false;
        this.buildIndex(null);

        this.totalRow = this.querySelector('[data-ve-total-row]');
        this.form = this.querySelector('.ve-estimate__form');
        this.input = this.form.querySelector('input');
        this.list = this.form.querySelector('.ve-combo__list');
        this.result = this.querySelector('.ve-estimate__result');
        this.options = [];
        this.active = -1;

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.closeList();
          this.show({ fresh: true });
        });

        /* Shipping and Total rows in the summary box (BNJMN, 19 Oct) */
        this.methods = this.querySelector('[data-ve-methods]');
        this.sum = this.querySelector('[data-ve-sum]');
        this.radios = [...this.methods.querySelectorAll('input[type="radio"]')];
        this.changeButton = this.querySelector('[data-ve-change]');
        this.remoteName = (() => {
          try {
            return JSON.parse(this.querySelector('[data-ve-remote-rate]').textContent) || '';
          } catch (error) {
            return '';
          }
        })();
        this.remotePrice = Number(this.querySelector('[data-ve-remote-price]')?.dataset.veRemotePrice) || 0;
        this.radios.forEach((radio) =>
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            this.choose(radio);
            this.changeButton.focus({ preventScroll: true });
          })
        );
        // Change: the city row opens again (and the choices, for a city with several rates)
        this.changeButton.addEventListener('click', () => {
          this.radios.forEach((radio) => (radio.checked = false));
          this.shipCents = null;
          this.sum.hidden = true;
          this.form.hidden = false;
          this.methods.hidden = !this.regularCity;
          this.updateTotal();
          this.save();
          (this.regularCity ? this.radios[0] : this.input).focus({ preventScroll: true });
        });
        // Dawn re-renders the subtotal after Remove: keep Total in step
        const live = this.closest('#main-cart-footer')?.querySelector('.js-contents');
        if (live) new MutationObserver(() => this.updateTotal()).observe(live, { childList: true, subtree: true });
        this.updateTotal();
        this.restore();

        const warm = () => this.ensureTowns();
        this.input.addEventListener('focus', warm, { once: true });
        this.input.addEventListener('pointerdown', warm, { once: true });
        this.input.addEventListener('input', () => {
          this.ensureTowns().then(() => this.suggest());
        });
        this.input.addEventListener('keydown', (event) => this.onKey(event));
        this.input.addEventListener('blur', () => this.closeList());
        // mousedown would blur the field before the click lands
        this.list.addEventListener('mousedown', (event) => event.preventDefault());
        this.list.addEventListener('click', (event) => {
          const option = event.target.closest('[role="option"]');
          if (option) this.pick(Number(option.dataset.index));
        });
      }

      ensureTowns() {
        if (this.townsLoaded) return Promise.resolve();
        return loadTowns(this.dataset.townsSrc).then((data) => {
          if (this.townsLoaded) return;
          this.townsLoaded = true;
          this.townsFailed = !data;
          this.buildIndex(data);
        });
      }

      /* One entry per name the shopper may type: { label, key, he, keys[] }.
         byKey maps every accepted spelling to its entry. */
      buildIndex(data) {
        const towns = data ? data.towns : [];
        const aliases = data ? data.aliases : [];
        const entries = [];
        const byKey = new Map();
        const add = (label, pair) => {
          label = String(label || '').trim();
          const key = norm(label);
          if (!key || byKey.has(key)) return;
          const parts = label.split(/\s+[-–־]\s+|\s*[\/()]\s*/).map(norm).filter((part) => part.length > 2);
          const he = HEBREW.test(label);
          const entry = { label, key, he, pair, parts, main: MAIN_TOWNS.has(norm(pair[0])), sound: he ? '' : soundKey(label) };
          entries.push(entry);
          byKey.set(key, entry);
        };
        towns.forEach((row) => {
          const pair = [row[0], row[1]].filter(Boolean);
          pair.forEach((name) => add(name, pair));
        });
        // common spellings ("Tel Aviv", "Kfar Saba", "מודיעין") stand for the town they name
        aliases.forEach(([name, town]) => {
          const target = byKey.get(norm(town));
          if (target) add(name, target.pair);
        });
        this.remoteNames.forEach((name) => add(name, [name]));
        this.extraNames.forEach((name) => add(name, [name]));
        // the parts of a double name ("תל אביב" in "תל אביב - יפו") are accepted too
        entries.forEach((entry) => {
          entry.parts.forEach((part) => {
            if (!byKey.has(part)) byKey.set(part, entry);
          });
        });
        // sound-alike keys that point at exactly one town
        const bySound = new Map();
        entries.forEach((entry) => {
          if (!entry.sound) return;
          const town = entry.pair[0];
          const seen = bySound.get(entry.sound);
          if (seen === undefined) bySound.set(entry.sound, entry);
          else if (seen && seen.pair[0] !== town) bySound.set(entry.sound, null);
        });
        this.entries = entries;
        this.byKey = byKey;
        this.bySound = bySound;
      }

      isRemote(entry, typed) {
        if (this.remote.has(norm(typed))) return true;
        if (!entry) return false;
        return entry.pair.some((name) => this.remote.has(norm(name)));
      }

      suggest() {
        const typed = this.input.value.trim();
        const query = norm(typed);
        if (!query) return this.closeList();
        const hebrew = HEBREW.test(typed);
        const sound = hebrew ? '' : soundKey(typed);
        const words = (label) => label.split(/[\s\-–־/()]+/).map(norm);
        const scored = [];
        this.entries.forEach((entry) => {
          if (entry.he !== hebrew) return;
          let score = -1;
          if (entry.key.startsWith(query)) score = 0;
          else if (words(entry.label).some((word) => word.startsWith(query))) score = 1;
          else if (query.length > 2 && entry.key.includes(query)) score = 2;
          else if (!hebrew && sound.length > 2 && entry.sound.startsWith(sound)) score = 3;
          if (score >= 0) scored.push([score, entry]);
        });
        scored.sort(
          (a, b) =>
            a[0] - b[0] ||
            b[1].main - a[1].main ||
            a[1].label.length - b[1].label.length ||
            a[1].label.localeCompare(b[1].label)
        );
        // one suggestion per town (the best-placed spelling)
        const towns = new Set();
        this.options = scored
          .map((item) => item[1])
          .filter((entry) => {
            const town = entry.pair[0];
            if (towns.has(town)) return false;
            towns.add(town);
            return true;
          })
          .slice(0, 8);
        // the exact name is already typed: nothing to suggest
        if (this.options.length === 1 && this.options[0].key === query) this.options = [];
        if (!this.options.length) return this.closeList();

        const id = this.list.id;
        this.list.replaceChildren(
          ...this.options.map((entry, index) => {
            const option = document.createElement('li');
            option.id = `${id}-${index}`;
            option.className = 've-combo__option';
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            option.dataset.index = String(index);
            option.dir = 'auto';
            if (entry.he) option.lang = 'he';
            option.textContent = entry.label;
            return option;
          })
        );
        this.active = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.list.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      setActive(index) {
        const count = this.options.length;
        if (!count) return;
        this.active = (index + count) % count;
        [...this.list.children].forEach((option, i) => {
          option.setAttribute('aria-selected', String(i === this.active));
        });
        const current = this.list.children[this.active];
        this.input.setAttribute('aria-activedescendant', current.id);
        current.scrollIntoView({ block: 'nearest' });
      }

      onKey(event) {
        const open = !this.list.hidden;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!open) {
            this.ensureTowns().then(() => {
              this.suggest();
              if (!this.list.hidden) this.setActive(0);
            });
            return;
          }
          this.setActive(this.active + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Enter' && open && this.active >= 0) {
          event.preventDefault();
          this.pick(this.active);
        } else if (event.key === 'Escape' && open) {
          event.preventDefault();
          event.stopPropagation();
          this.closeList();
        } else if (event.key === 'Tab') {
          this.closeList();
        }
      }

      pick(index) {
        const entry = this.options[index];
        if (!entry) return;
        this.input.value = entry.label;
        this.closeList();
        this.input.focus();
      }

      closeList() {
        if (!this.list) return;
        this.list.hidden = true;
        this.list.replaceChildren();
        this.options = [];
        this.active = -1;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }

      show(options = {}) {
        return this.ensureTowns().then(() => this.render(options));
      }

      /* "₪190" / Hebrew site "190 ₪", like snippets/ve-price.liquid */
      price(cents) {
        const amount = (cents / 100).toLocaleString('en-US', {
          minimumFractionDigits: cents % 100 ? 2 : 0,
          maximumFractionDigits: 2,
        });
        return (document.documentElement.lang || '').startsWith('he') ? `${amount}\u00a0₪` : `₪${amount}`;
      }

      subtotal() {
        const node = this.closest('#main-cart-footer')?.querySelector('[data-ve-subtotal]');
        return node ? Number(node.dataset.veSubtotal) : null;
      }

      /* The city row folds into one Shipping row: "City · rate name  Change  ₪40" */
      setShipping(name, cents) {
        this.shipCents = cents;
        this.sum.querySelector('[data-ve-ship-price]').textContent = this.price(cents);
        this.sum.querySelector('[data-ve-ship-name]').textContent = name;
        this.sum.querySelector('[data-ve-ship-city]').textContent = this.cityLabel || this.input.value.trim();
        this.form.hidden = true;
        this.methods.hidden = true;
        this.sum.hidden = false;
        this.updateTotal();
      }

      /* Total is always shown: "₪230 + shipping" until a rate is set, then subtotal + shipping */
      updateTotal() {
        const row = this.totalRow || (this.totalRow = this.querySelector('[data-ve-total-row]'));
        const subtotal = this.subtotal();
        row.hidden = subtotal === null;
        if (row.hidden) return;
        const set = this.shipCents != null;
        row.querySelector('[data-ve-total]').textContent = this.price(subtotal + (set ? this.shipCents : 0));
        row.querySelector('[data-ve-plus]').hidden = set;
        // Phones: "Shipping · city · method  ₪40" in the box, before Total, once a method is set
        const line = this.shipLine;
        if (line) {
          line.hidden = !set || !line.isConnected;
          if (!line.hidden) {
            const name = this.sum.querySelector('[data-ve-ship-name]').textContent;
            const city = this.sum.querySelector('[data-ve-ship-city]').textContent;
            line.querySelector('[data-ve-line-what]').textContent = [city, name].filter(Boolean).join(' · ');
            line.querySelector('[data-ve-line-price]').textContent = this.price(this.shipCents);
          }
        }
      }

      choose(radio) {
        this.setShipping(radio.dataset.name, Number(radio.dataset.price) || 0);
        this.save();
      }

      save() {
        try {
          const checked = this.radios.find((radio) => radio.checked);
          sessionStorage.setItem(
            've-ship-estimate',
            JSON.stringify({ city: this.input.value.trim(), method: checked ? checked.value : null })
          );
        } catch (error) {
          /* storage off: the pick just isn't remembered */
        }
      }

      restore() {
        let saved = null;
        try {
          saved = JSON.parse(sessionStorage.getItem('ve-ship-estimate') || 'null');
        } catch (error) {
          saved = null;
        }
        if (!saved || !saved.city) return;
        this.input.value = saved.city;
        this.show({ quiet: true, method: saved.method });
      }

      render(options = {}) {
        const city = this.input.value.trim();
        const key = norm(city);
        let entry = this.byKey.get(key);
        if (!entry && !HEBREW.test(city)) entry = this.bySound.get(soundKey(city)) || undefined;
        const accepted = !this.onlyListed || this.townsFailed || Boolean(entry) || this.remote.has(key);
        const known = city !== '' && accepted;
        const isRemote = known && this.isRemote(entry, city);
        this.result.hidden = false;
        this.result.querySelector('[data-ve-estimate-empty]').hidden = city !== '';
        this.result.querySelector('[data-ve-estimate-unknown]').hidden = city === '' || accepted;
        // a new Calculate starts the pick again
        this.radios.forEach((radio) => (radio.checked = options.method != null && radio.value === String(options.method)));
        this.shipCents = null;
        this.sum.hidden = true;
        this.form.hidden = false;
        this.methods.hidden = true;
        this.regularCity = known && !isRemote;
        this.cityLabel = known ? (entry ? entry.label : city) : '';
        this.updateTotal();
        if (known && isRemote) {
          this.setShipping(this.remoteName, this.remotePrice);
        } else if (known) {
          const picked = this.radios.find((radio) => radio.checked);
          if (picked) this.choose(picked);
          else this.methods.hidden = false;
        }
        if (!options.quiet) this.save();
        if (!known && !options.quiet) this.input.focus();
      }
    }
  );
}

/* Phones (BNJMN, 20 Oct): the shipping calculator sits under the order note behind a
   "Get shipping estimates" row (closed at first); the Total row stays in the grey box.
   Computers: everything back in the box. Setting "Phones: shipping estimates under the note". */
(() => {
  const setup = () => {
    const out = document.querySelector('[data-ve-ship-out]');
    const est = document.querySelector('ve-ship-estimate');
    if (!out || !est || out.dataset.veReady) return;
    out.dataset.veReady = '1';
    const panel = out.querySelector('.ve-ship-out__panel');
    const toggle = out.querySelector('.ve-ship-out__toggle');
    const total = est.totalRow || est.querySelector('[data-ve-total-row]');
    est.totalRow = total;
    const marker = document.createComment('ve-estimate');
    est.before(marker);
    const mq = window.matchMedia('all'); /* computers too since 20 Oct, later */
    const line = document.createElement('p');
    line.className = 've-estimate__shipline';
    line.hidden = true;
    const label = document.createElement('span');
    label.textContent = est.querySelector('[data-ve-sum] .ve-estimate__label')?.textContent || '';
    const what = document.createElement('span');
    what.className = 've-estimate__shipline-what';
    what.dir = 'auto';
    what.dataset.veLineWhat = '';
    /* "Change" in the Shipping row under Subtotal (computers, 2 Nov; assets/ve-cart-side.css hides it elsewhere) */
    const change = document.createElement('button');
    change.type = 'button';
    change.className = 've-estimate__shipline-change';
    change.textContent = est.querySelector('[data-ve-change]')?.textContent || '';
    change.addEventListener('click', () => {
      est.querySelector('[data-ve-change]')?.click();
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    });
    const left = document.createElement('span');
    left.append(label, ' ', what, ' ', change);
    const price = document.createElement('span');
    price.dataset.veLinePrice = '';
    line.append(left, price);
    est.shipLine = line;
    const place = () => {
      if (mq.matches) {
        if (total) marker.after(line, total);
        if (est.parentNode !== panel) panel.append(est);
      } else {
        if (est.parentNode === panel) marker.after(est);
        if (total && total.parentNode !== est) est.insertBefore(total, est.querySelector('script'));
        line.remove();
      }
      if (est.updateTotal) est.updateTotal();
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    });
    mq.addEventListener('change', place);
    place();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
